import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoGuz: CultureInfo = {
  name: 'guz',
  displayName: 'Ekegusii',
  iso3LanguageCode: 'guz',
  iso2LanguageCode: 'guz',
  ietfLanguageTag: 'guz',
  parent: null
};
